import { MATCH_NAV_DIRECTION } from "./const";

export const sumSectionMatchesCount = (section) =>
  section.reduce((acc, group) => acc + group.count, 0);

export const getGroupIndex = (section, activeMatchIndex) => {
  let count = 0;

  for (let i = 0; i < section.length; i++) {
    const group = section[i];

    count += group.count;
    if (count > activeMatchIndex) {
      return i;
    }
  }

  return -1;
};

const calcGroupMatchesMetadata = (group, sectionIndex, activeSectionIndex) => {
  let activeMatchIndexOffset = 0;
  let matchesCount = 0;

  for (let groupIndex = 0; groupIndex < group.length; groupIndex++) {
    const groupMatchesCount = group[groupIndex].count;

    matchesCount += groupMatchesCount;
    if (sectionIndex < activeSectionIndex) {
      activeMatchIndexOffset += groupMatchesCount;
    }
  }
  return { activeMatchIndexOffset, matchesCount };
};

export const calcMatchesMetadata = (matches, activeSectionIndex) => {
  let activeMatchIndexOffset = 0;
  let matchesCount = 0;

  for (let sectionIndex = 0; sectionIndex < matches.length; sectionIndex++) {
    const group = matches[sectionIndex];
    const groupMatches = calcGroupMatchesMetadata(
      group,
      sectionIndex,
      activeSectionIndex
    );
    matchesCount += groupMatches.matchesCount;
    activeMatchIndexOffset += groupMatches.activeMatchIndexOffset;
  }

  return { activeMatchIndexOffset, matchesCount };
};

export const getPrevSectionIndex = (matches, activeSectionIndex) => {
  for (let i = activeSectionIndex - 1; i >= 0; i--) {
    if (sumSectionMatchesCount(matches[i]) > 0) {
      return i;
    }
  }

  for (let i = matches.length - 1; i >= activeSectionIndex; i--) {
    if (sumSectionMatchesCount(matches[i]) > 0) {
      return i;
    }
  }

  return -1;
};

export const getNextSectionIndex = (matches, activeSectionIndex) => {
  for (let i = activeSectionIndex + 1; i < matches.length; i++) {
    if (sumSectionMatchesCount(matches[i]) > 0) {
      return i;
    }
  }

  for (let i = 0; i <= activeSectionIndex; i++) {
    if (sumSectionMatchesCount(matches[i]) > 0) {
      return i;
    }
  }

  return -1;
};

const calcSucceedingPrevMatch = ({
  matches,
  activeMatchIndex,
  activeSectionIndex,
  currentMatch,
}) => {
  let sectionIndex = activeSectionIndex;
  let matchIndex = activeMatchIndex - 1;

  if (activeMatchIndex - 1 < 0) {
    const prevSectionIndex = getPrevSectionIndex(matches, activeSectionIndex);
    if (prevSectionIndex < 0) {
      return currentMatch;
    }
    sectionIndex = prevSectionIndex;
    matchIndex = sumSectionMatchesCount(matches[sectionIndex]) - 1;
  }

  const groupIndex = getGroupIndex(matches[sectionIndex], matchIndex);

  return { sectionIndex, groupIndex, matchIndex };
};

const calcSucceedingNextMatch = ({
  matches,
  activeMatchIndex,
  activeSectionIndex,
  currentMatch,
}) => {
  let sectionIndex = activeSectionIndex;
  let matchIndex = activeMatchIndex + 1;

  const sectionMatchesCount = sumSectionMatchesCount(
    matches[activeSectionIndex]
  );

  if (activeMatchIndex + 1 >= sectionMatchesCount) {
    const nextSectionIndex = getNextSectionIndex(matches, activeSectionIndex);
    if (nextSectionIndex < 0) {
      return currentMatch;
    }
    sectionIndex = nextSectionIndex;
    matchIndex = 0;
  }

  const groupIndex = getGroupIndex(matches[sectionIndex], matchIndex);

  return { sectionIndex, matchIndex, groupIndex };
};

export const calcSucceedingMatch = ({
  direction,
  matches,
  activeMatchIndex,
  activeSectionIndex,
}) => {
  const currentMatch = {
    sectionIndex: activeSectionIndex,
    matchIndex: activeMatchIndex,
    groupIndex: -1,
  };

  if (direction === MATCH_NAV_DIRECTION.PREV) {
    return calcSucceedingPrevMatch({
      matches,
      activeMatchIndex,
      activeSectionIndex,
      currentMatch,
    });
  }

  if (direction === MATCH_NAV_DIRECTION.NEXT) {
    return calcSucceedingNextMatch({
      matches,
      activeMatchIndex,
      activeSectionIndex,
      currentMatch,
    });
  }

  return currentMatch;
};
